(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["whatsapp-widget"] && !Shopify.designMode) return;
  try {
    (function() {
  var fab = document.getElementById('wa-fab');
  var dropdown = document.getElementById('wa-dropdown');
  var widget = document.getElementById('wa-widget');
  if (!fab || !dropdown || !widget) return;

  fab.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = dropdown.getAttribute('aria-hidden') === 'false';
    dropdown.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    fab.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  });

  document.addEventListener('click', function(e) {
    if (!widget.contains(e.target)) {
      dropdown.setAttribute('aria-hidden', 'true');
      fab.setAttribute('aria-expanded', 'false');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
